import { render, staticRenderFns } from "./SettingsIntegrations.vue?vue&type=template&id=8bb0b048&"
import script from "./SettingsIntegrations.vue?vue&type=script&lang=js&"
export * from "./SettingsIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports